import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'scaffold-integration-banner',
  templateUrl: './integration-banner.component.html',
  styleUrls: ['./integration-banner.component.scss']
})


export class IntegrationBannerComponent implements OnInit{
  @Input() integration: any;

  constructor() {}

  ngOnInit() {
    console.log(this.integration);
  }

  getLogo(integration) {
    if(integration.lms_type === 'canvas') {
      return 'https://k16-hosted-lib.s3.us-east-2.amazonaws.com/canvas.png';
    }else if(integration.sis_type === 'banner') {
      return 'https://k16-hosted-lib.s3.us-east-2.amazonaws.com/banner.png';
    } else if(integration.lms_type === 'moodle') {
      return 'https://k16-hosted-lib.s3.us-east-2.amazonaws.com/moodle.png';
    }
    return 'https://k16-hosted-lib.s3.us-east-2.amazonaws.com/placeholder.png';
  }

  getTypeColor(integration) {
    if(integration.integration_type === 'lms') {
      return 'background-color: #3f8a94; color: white;';
    }else if(integration.integration_type === 'sis') {
      return 'background-color: #f2862e; color: white;';
    }
    return 'background-color: transparent;';
  }

}
